import { Box, Divider, Heading, Icon, Link, VStack } from "@chakra-ui/react";
import {
    FaCreditCard,
    FaHandsHelping,
    FaDashcube, FaProductHunt, FaSwatchbook, FaImages
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
import useAuthentication from "~/hooks/useAuthentication.ts";
import useExtendedNavigation from "~/hooks/useExtendedNavigation.ts";


const Sidebar = () => {
    const location = useLocation();
    const {getBaseAppUrl} = useAuthentication();
    const navigate = useExtendedNavigation();
    // Sidebar links with paths to check active state
    const sidebarLinks = [
        { label: "Dashboard", icon: FaDashcube, href: `/${getBaseAppUrl()}dashboard` },
        { label: "Models", icon: FaSwatchbook, href: `/${getBaseAppUrl()}models` },
        { label: "Generate Images", icon: FaImages, href: `/${getBaseAppUrl()}generate-images` },
        { label: "Product Images", icon: FaProductHunt, href: `/${getBaseAppUrl()}products/images` },
        { label: "Theme Images", icon: FaImages, href: `/${getBaseAppUrl()}theme/images` },
        { label: "Galleries", icon: FaDashcube, href: `/${getBaseAppUrl()}galleries` },
    ];

    const bottomLinks = [
        { label: "Billing", icon: FaCreditCard, href: `/${getBaseAppUrl()}billing` },
        { label: "Support", icon: FaHandsHelping, href: `/${getBaseAppUrl()}support` },
    ];

    const handleNavigation = (href: string) => {
        navigate(href);
    }

    return (
        <Box
            w="250px"
            p="5"
            bg="gray.900"
            color="primary.0"
            height="100vh"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            overflowY="auto"
        >
            <VStack align="stretch" spacing="4" flex="1" overflowY="auto">
                <Heading size="md">CARTARIO</Heading>
                <Divider borderColor="primary.0" />

                {/* Sidebar Links */}
                {sidebarLinks.map((link, index) => (
                    <Link
                        key={index}
                        display="flex"
                        alignItems="center"
                        onClick={() => handleNavigation(link.href)}
                        color={location.pathname === link.href ? "body.2" : "primary.0"} // Active link color from theme
                        fontWeight={location.pathname === link.href ? "bold" : "normal"} // Bold for active link
                        _hover={{ color: "body.2" }} // Hover effect with active link color
                    >
                        <Icon as={link.icon} mr="2" color="primary.0" /> {/* Icon color from theme */}
                        {link.label}
                    </Link>
                ))}
            </VStack>

            <VStack align="stretch" spacing="4" mt="4">
                <Divider borderColor="primary.0" />

                {bottomLinks.map((link, index) => (
                    <Link
                        key={index}
                        display="flex"
                        alignItems="center"
                        onClick={() => handleNavigation(link.href)}
                        color={location.pathname === link.href ? "body.2" : "primary.0"}
                        fontWeight={location.pathname === link.href ? "bold" : "normal"}
                        _hover={{ color: "body.2" }}
                    >
                        <Icon as={link.icon} mr="2" color="primary.0" />
                        {link.label}
                    </Link>
                ))}
            </VStack>
        </Box>
    );
};

export default Sidebar;
